import { api } from './axios'
import type {
  ConfirmUserDto,
  ConfirmUserResponseDto,
  CreateTenantPublicDto,
  ResendConfirmationCodeDto,
  ResendConfirmationCodeResponseDto,
  TenantDto,
  VerifyEmailForDeletionDto,
  VerifyEmailForDeletionResponseDto,
} from './types'

export const createPublicTenant = async (tenant: CreateTenantPublicDto) => {
  const response = await api.post<TenantDto>('/public/tenant', tenant, {
    headers: {
      accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })

  return response.data
}

/**
 * Resend confirmation code to user email
 */
export const resendConfirmationCode = async (
  data: ResendConfirmationCodeDto,
): Promise<ResendConfirmationCodeResponseDto> => {
  const response = await api.post<ResendConfirmationCodeResponseDto>(
    '/public/confirmation/resend',
    data,
    {
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
      },
    },
  )

  return response.data
}

/**
 * Confirm user with confirmation code
 */
export const confirmUser = async (data: ConfirmUserDto): Promise<ConfirmUserResponseDto> => {
  const response = await api.post<ConfirmUserResponseDto>('/public/confirmation/confirm', data, {
    headers: {
      accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })

  return response.data
}

/**
 * Verify email for account deletion request
 */
export const verifyEmailForDeletion = async (
  data: VerifyEmailForDeletionDto,
): Promise<VerifyEmailForDeletionResponseDto> => {
  const response = await api.post<VerifyEmailForDeletionResponseDto>(
    '/public/delete-account/verify-email',
    data,
    {
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
      },
    },
  )

  return response.data
}
